import { Scissors } from "lucide-react";
import { BOOKSY_URL } from "@/lib/config";

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/10 pt-20 pb-8 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-5">
              <Scissors className="w-5 h-5 text-[#FF3333]" />
              <span className="font-display font-black text-xl uppercase">
                McNeal<span className="text-[#FF3333]">Cutz</span>
              </span>
            </div>
            <p className="text-white/50 font-light max-w-md leading-relaxed">
              Monroe's home for sharp cuts and bold style. Every chair tells a story.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.25em] uppercase text-[#FF3333] mb-4">Visit</div>
            <ul className="space-y-2 text-white/60 text-sm">
              <li>2006 Prairie Rd</li>
              <li>Monroe, LA 71202</li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="text-xs tracking-[0.25em] uppercase text-[#FF3333] mb-4">Quick</div>
            <ul className="space-y-2 text-white/60 text-sm">
              <li><a href="#services" className="hover:text-white">Services</a></li>
              <li><a href="#barbers" className="hover:text-white">Barbers</a></li>
              <li><a href="#gallery" className="hover:text-white">Gallery</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="text-xs tracking-[0.25em] uppercase text-[#FF3333] mb-4">More</div>
            <ul className="space-y-2 text-white/60 text-sm">
              <li><a href="#about" className="hover:text-white">About</a></li>
              <li><a href="#contact" className="hover:text-white">Contact</a></li>
              <li>
                <a
                  href={BOOKSY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-booksy-link"
                  className="hover:text-[#FF3333]"
                >
                  Book on Booksy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="font-display font-black uppercase leading-none tracking-tighter text-[18vw] md:text-[14vw] text-white/[0.04] select-none">
            McNealCutz
          </div>
        </div>

        <div className="text-xs text-white/30 mt-6 flex flex-col md:flex-row md:justify-between gap-2">
          <div>© {new Date().getFullYear()} McNeal Cutz. All rights reserved.</div>
          <div>Sharp Cuts. Bold Style. Monroe, LA.</div>
        </div>
      </div>
    </footer>
  );
}
